var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToProtonmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4993 0.0187337C12.4993 0.0187337 5.42908 -0.213767 3.9707 7.62936V12.975C3.9707 12.975 4.0307 13.5469 5.63945 14.7075C7.2482 15.8681 11.4096 19.1347 12.4993 19.1347C13.5891 19.1347 17.752 15.8655 19.3596 14.7041C20.9672 13.5427 21.0283 12.9716 21.0283 12.9716V7.62936C19.5696 -0.213767 12.4993 0.0187337 12.4993 0.0187337ZM17.3368 10.5375H7.66183V7.62523C8.63683 3.73498 12.4993 3.68098 12.4993 3.68098C12.4993 3.68098 16.3618 3.73461 17.3368 7.62973V10.5375ZM12.4993 20.3377C12.4993 20.3377 11.4036 20.2305 10.5493 19.635L3.9707 14.9542V23.0415C3.9707 23.0415 4.01945 23.979 5.0552 23.979H19.9427C20.9788 23.979 21.0272 23.0415 21.0272 23.0415V14.9542L14.4493 19.635C13.5917 20.2305 12.4993 20.3377 12.4993 20.3377Z",
    fill: "#8A90C7",
    stroke: "white",
    strokeWidth: 0.095,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToProtonmail);
export default __webpack_public_path__ + "static/media/toProtonmail.21fb645326d8d28a9842e45263d5493e.svg";
export { ForwardRef as ReactComponent };